<template>
  <div class="checklist-input">
    <q-input ref="input" v-model.trim="input" outlined dense @keydown.enter="$emit('save')" />

    <div class="actions">
      <q-btn size="sm" class="q-mr-sm q-mt-xs" @click="$emit('cancel')">
        Cancel
      </q-btn>

      <q-btn :disable="!input" size="sm" class="q-mt-xs" color="tertiary" @click="$emit('save')">
        {{ saveBtnText }}
      </q-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    saveBtnText: {
      type: String,
      default: 'Save'
    }
  },

  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    focus() {
      this.$nextTick(() => this.$refs.input.focus())
    }
  }
}
</script>
